<script setup lang="ts">
withDefaults(defineProps<{
  showIndex: boolean
  inverterNumber: number
  brand: string
  power?: string | number
  serial: string
  plantName?: string
}>(), {
  plantName: undefined,
})

const { t } = useI18n()
</script>

<template>
  <div class="bg-brand-secondary-light w-full md:site:max-w-[372px]">
    <div v-if="showIndex" class="inverter-card-title">
      {{ inverterNumber }}º {{ t('inversorInstallation.InversorInstallationConfirmation.InverterCard.inverter') }}
    </div>

    <div class="inverter-card">
      <img class="hidden md:site:block" src="/images/inverter.svg" alt="logo do inversor">

      <dl class="inverter-details">
        <div class="inverter-detail-line">
          <dt class="inverter-detail-key">
            {{ t('inversorInstallation.InversorInstallationConfirmation.InverterCard.brand') }}
          </dt>
          <dd class="inverter-detail-value">
            {{ brand }}
          </dd>
        </div>

        <div v-if="plantName" class="inverter-detail-line">
          <dt class="inverter-detail-key">
            Nome da planta
          </dt>
          <dd class="inverter-detail-value">
            {{ plantName }}
          </dd>
        </div>

        <div v-if="power" class="inverter-detail-line">
          <dt class="inverter-detail-key">
            {{ t('inversorInstallation.InversorInstallationConfirmation.InverterCard.potency') }}
          </dt>
          <dd class="inverter-detail-value">
            {{ power }} kW
          </dd>
        </div>

        <SolDivider thickness="x-small" orientation="horizontal" />

        <div class="inverter-detail-line">
          <dt class="inverter-detail-key">
            {{ t('inversorInstallation.InversorInstallationConfirmation.InverterCard.serialNumber') }}
          </dt>
          <dd class="inverter-detail-value">
            {{ serial }}
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<style scoped lang="scss">
.inverter-card-title {
  @apply flex flex-row justify-center items-center;
  @apply py-nano px-4xs;
  @apply border border-solid border-feedback-positive-medium;
  @apply border-b-none;
  @apply rounded-t-md;
  @apply text-3xs font-bold text-brand-secondary-pure;
}

.inverter-card {
  @apply flex flex-row gap-4 justify-start md:site:justify-center items-center;
  @apply py-2xs px-4xs;
  @apply rounded-md border border-solid border-neutral-high-dark;
  @apply rounded-t-none;
  background-color: #FBFBFB;

  >.inverter-details {
    @apply flex flex-col justify-center gap-2;

    >.inverter-detail-line {
      @apply flex flex-row gap-1 text-3xs;

      >.inverter-detail-key {
        @apply text-neutral-low-medium font-bold;
      }

      >.inverter-detail-value {
        @apply text-neutral-low-light;
      }
    }
  }
}
</style>
